//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Genres from "@/containers/Genres";
import HomeSlider from "@/components/homeSlider.comp.vue";
export default {
  name: "Home",
  computed: {
    ...mapGetters(["tvshows","popularTvShows"]),
    limitPopularTvshow(){
      return this.popularTvShows.slice(0,5)
    }
  },
  components: {
    Genres,
    HomeSlider
  }
};
